<template>
    <admin-layout 
    title="Create Voucher"
    show-back
    backUrl="/vouchers">
        <div class="p-7">
            <FormSection
                :form="form"
                :packages="packages"
                :services="services"
                :allergyTests="allergyTests"
                :patients="patients"
                :packageOptions="packageOptions"
                :riderOptions="riderOptions"
                :patientOptions="patientOptions"
                :maxUsageOptions="maxUsageOptions"
                :requirementOptions="requirementOptions"
                :discountOptions="discountOptions"
                :validityRangeOptions="validityRangeOptions"
                :errors="errors"
            >
                <div class="block">
                    <ButtonComponent @click="showConfirmation = true">
                        Create Voucher
                    </ButtonComponent>
                    <div class="text-sm text-gray-600 ">
                        <b>Note:</b> once the voucher is created it can no longer be updated
                    </div>
                </div>
            </FormSection>
        </div>

        <PageLoader v-if="loader" />

        <ErrorModal
            width="w-[548px]"
            title="Error"
            action-text="Close"
            cancel-text="Go back"
            :show="showError"
            @close="showError = false"
            @confirm="showError = false"
            :errors="errors"
        >
            <template #content>
                {{ errorMsg }}
            </template>
        </ErrorModal>

        <SuccessModal
            :show="showSuccess"
            @cancel="showSuccess = false"
            @confirm="showSuccess = false"
            action-text="Close"
            title="Voucher"
            content="Voucher Created Successfully!"
        />

        <ConfirmationModal
            :show="showConfirmation"
            @cancel="showConfirmation = false"
            @confirm="showConfirmation = false; submit()"
            cancel-text="Cancel"
            action-text="Confirm"
            title="Confirm Voucher Creation?"
            content="Once the voucher is created it can no longer be updated."
        />

    </admin-layout>
</template>

<script setup lang="ts">
import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

import { ref, onMounted } from 'vue';
import VoucherService from '@/classes/Voucher';
import AuthService from '@/classes/AuthService';

const form = ref({
    name: null,
    code: null,
    package_type: null,
    rider_type: null,
    patient_type: null,
    max_usage_type: null,
    max_usage_count: null,
    requirement_type: null,
    requirement_value: null,
    discount_type: null,
    discount_value: null,
    validity_range_type: null,
    start_at: null,
    end_at: null,
    description: null,
    package_id: [],
    rider_ids: [],
    patient_ids: [],
})

const packages = ref([]);
const services = ref([]);
const allergyTests = ref([]);
const patients = ref([]);
const packageOptions = ref([]);
const riderOptions = ref([]);
const patientOptions = ref([]);
const maxUsageOptions = ref([]);
const requirementOptions = ref([]);
const discountOptions = ref([]);
const validityRangeOptions = ref([]);


const loader = ref(false)
const showSuccess = ref(false);
const showConfirmation = ref(false);
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])

const fetchDropdownsData = () => {
    loader.value = true

    VoucherService.createVoucher()
        .then((result: any) => {
            packages.value = result?.data?.packages;
            services.value = result?.data?.services
            allergyTests.value = result?.data?.allergyTests
            patients.value = result?.data?.patients
            packageOptions.value = result?.data?.packageOptions
            riderOptions.value = result?.data?.riderOptions
            patientOptions.value = result?.data?.patientOptions
            maxUsageOptions.value = result?.data?.maxUsageOptions
            requirementOptions.value = result?.data?.requirementOptions
            discountOptions.value = result?.data?.discountOptions
            validityRangeOptions.value = result?.data?.validityRangeOptions

            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

/**
 * Submit
 */
const submit = async () => {
    loader.value = true;

    try {
        form.value.code = form.value.code ? form.value.code.toUpperCase() : null;

        await VoucherService.storeVoucher(form.value)

        showSuccess.value = true
                
        setTimeout(() => {
            window.location.replace('/vouchers')
        }, 1000);
    }
    catch(error) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;

        if(error.response.status == 422) {
            errors.value = error.response.data.errors;
        }
        errorResponse(error)
    }
}

const errorResponse = (err: object) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}

onMounted(async() => {
    await fetchDropdownsData();
})

</script>